export { TomtomTrafficSelectComponent } from './lib/tomtom-traffic-select/tomtom-traffic-select.component';
export { TomtomStylesService } from './lib/tomtom-styles.service';
export { TomtomMapService } from './lib/tomtom-map.service';

export * from './lib/traffic.module';
